"use client";

import { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import i18nBase from "../i18n";

// `lang` comes from the root layout ((id) or (en)), so SSR renders the right language.
// Each Providers gets its own i18n clone (shared resources) to avoid cross-request language leaks.
export default function Providers({
  lang,
  children,
}: {
  lang: "id" | "en";
  children: React.ReactNode;
}) {
  const [i18n] = useState(() => i18nBase.cloneInstance({ lng: lang }));

  useEffect(() => {
    // /en is fixed by URL; id routes (e.g. blog, no EN twin) honour the saved preference.
    const savedLang = lang === "en" ? "en" : localStorage.getItem("i18nextLng") || "id";
    if (i18n.language !== savedLang) {
      i18n.changeLanguage(savedLang);
    }
    document.documentElement.lang = savedLang === "en" ? "en" : "id";
  }, [lang, i18n]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

